<template>
  <auth-layout>
    <div>
      <div class="mb-5">
        <h1 class="fw-bold text-uppercase mb-2">
          Inicio de Sesión
        </h1>
        <p class="text-muted mb-0">
          Bienvenido al portal del empleado IUSA.
        </p>
      </div>

      <div
        class="alert alert-danger"
        role="alert"
        v-if="hasError"
      >
        {{ msg }}.
      </div>

      <form @submit.prevent="submit">
        <!-- Username Input -->       
        <username-input
          id="username"
          name="username"
          autocomplete="username"
          v-model="form.employee_code"                
          placeholder="No Empleado"
          :class="{ 'is-invalid': hasError }"
        />
        <!-- Password Input -->
        <password-input
          id="current-password"
          name="current-password"
          autocomplete="current-password"
          v-model="form.password"
          :class="{ 'is-invalid': hasError }"                
        />

        <div class="form-check mb-4">
          <input
            class="form-check-input"
            type="checkbox"
            id="remember"
            name="remember"
          />
          <label class="form-check-label" for="remember">
            Recordar Password
          </label>
        </div>

        <div class="mb-4 d-flex justify-content-center justify-content-lg-start">
          <vue-recaptcha
            :sitekey="catpcha"
            @verify="onVerify"
            @expired="onExpired"
          />
        </div>

        <button
          type="submit"
          class="btn btn-portal btn-lg w-100 text-uppercase"
          :disabled="procesando"
        >
          {{ procesando ? "Validando..." : "Ingresar" }}
        </button>

        <div class="mt-3 text-center">
          <router-link
            :to="{ name: 'ForgottenPassword' }"
            class="link-primary"
          >
            ¿Has olvidado tu contraseña?
          </router-link>     
          
          <div class="mt-2">
            ¿No tienes cuenta?
            <router-link
              :to="{ name: 'Register' }"
              class="link-primary"
            >
              Regístrate aquí
            </router-link>
          </div>
        </div>          
      </form>
    </div>
  </auth-layout>      
</template>


<script>
import { mapActions } from "vuex";
import VueRecaptcha from "vue-recaptcha";
import UsernameInput from './components/UsernameInput.vue';
import PasswordInput from './components/PasswordInput.vue';
import AuthLayout from '@/template/AuthLayout.vue';
export default {
  name: "SignIn",
  components: {
    VueRecaptcha,
    UsernameInput,
    PasswordInput,
    AuthLayout
  },
  data() {
    return {
      catpcha: process.env.VUE_APP_GOOGLE_SITEKEY,
      procesando: false,
      hasError: false,
      recaptcha: null,
      msg: null,
      form: {
        employee_code: "",
        password: "",
      },      
    };
  },
  methods: {
    ...mapActions({
      signIn: "auth/signIn",
    }),
    onVerify: function (response) {
      this.recaptcha = response;
    },
    onExpired: function () {
      this.recaptcha = null;
    },
    submit() {
      if (this.recaptcha != null) {
        this.procesando = true;
        this.signIn(this.form)
          .then((response) => {
            //console.log(response);
            if (response) {
              this.msg = response;
              this.procesando = false;
              this.hasError = true;
              setTimeout(() => {
                this.hasError = false;
              }, 5000);
              this.form.password = null;
            } else {
              this.$router.replace({
                name: "Home",
              });
            }
          })
          /*.then(() => {
            this.$router.replace({
              name: "Home",
            });
          })*/
          .catch(() => {
            this.msg = "Usuario y/o contraseña incorrectos";
            this.procesando = false;
            this.hasError = true;
            setTimeout(() => {
              this.hasError = false;
            }, 5000);
            this.form.password = null;
          });
      } else {
        this.hasError = true;
        setTimeout(() => {
          this.hasError = false;
        }, 5000);
        this.msg = "El campo reCAPTCHA es obligatorio";
      }
    },
  },
};
</script>
